import React from 'react'
import { Button, Col, Row } from '@themesberg/react-bootstrap'
import { disableTicketRoll, enableTicketRoll } from '../../../../controller/api/systemApi';
import { useCookies } from 'react-cookie';

const REGION_LABEL = {
  MB: 'Miền Bắc',
  MT: 'Miền Trung',
  MN: 'Miền Nam',
}

export const ResultItem = ({ isRollEnabled, region = '', onChanged }) => {

  const [cookies] = useCookies(['lottmekong']);

  const onEnableClick = async () => {
    await enableTicketRoll(cookies.lottmekong, '', true, false, false, region)
    if (onChanged) onChanged()
  }

  const onDisableClick = async () => {
    await disableTicketRoll(cookies.lottmekong, '', true, false, false, region)
    if (onChanged) onChanged()
  }

  const regionLabel = REGION_LABEL[region] || ''

  return (
    <div className="shadow-md p-2 mb-4" style={{ backgroundColor: '#fff' }}>
      <div style={{ fontSize: 15 }}>
        <Row>
          {isRollEnabled ?
            <Col>
              <Button variant="danger" size="sm" onClick={onDisableClick}>Tắt chia vé</Button>
            </Col>
            :
            <Col>
              <Button variant="success" size="sm" onClick={onEnableClick}>Bật chia vé</Button>
            </Col>
          }
          <Col>
            <b>Trạng thái chia vé KT{regionLabel ? ` (${regionLabel})` : ''}</b>
          </Col>
          <Col className='text-right'>
            <b>{isRollEnabled ? 'Đang bật' : 'Đang tắt'}</b>
          </Col>
        </Row>
      </div>
    </div>
  );
};